/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Customer } from '../models';
// @ts-ignore
import type { CustomerPatchModel } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { InvoiceModel } from '../models';
// @ts-ignore
import type { InvoicesModel } from '../models';
// @ts-ignore
import type { SubscriptionModel } from '../models';
// @ts-ignore
import type { SubscriptionResponseModel } from '../models';
/**
 * ManageAccountAndSubscriptionsApi - axios parameter creator
 * @export
 */
export const ManageAccountAndSubscriptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API to delete subscription
         * @summary delete subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscription: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/accounts/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to get billing info
         * @summary get billing info of customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/accounts/customer/billingInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to retrieve current usage of customer
         * @summary get current usage of a customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUsage: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/accounts/usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to get customer url
         * @summary get stripe customer portal url
         * @param {string} redirectUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerURL: async (redirectUrl: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redirectUrl' is not null or undefined
            assertParamExists('getCustomerURL', 'redirectUrl', redirectUrl)
            const localVarPath = `/api/v1/accounts/customer/getPortalURL`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (redirectUrl !== undefined) {
                localVarQueryParameter['redirect_url'] = redirectUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to get invoice data
         * @summary get invoice data
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoice: async (invoiceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('getInvoice', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/accounts/invoices/{invoice_id}`
                .replace(`{${"invoice_id"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to get all invoices
         * @summary get all invoices
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices: async (startDate?: string, endDate?: string, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/accounts/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to fetch historical customer usage data for closed billing periods
         * @summary fetch historical customer usage data for closed billing periods
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {string} [billableMetricCode] 
         * @param {number} [periodsCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPastUsage: async (page?: number, perPage?: number, billableMetricCode?: string, periodsCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/accounts/usage/past`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (billableMetricCode !== undefined) {
                localVarQueryParameter['billable_metric_code'] = billableMetricCode;
            }

            if (periodsCount !== undefined) {
                localVarQueryParameter['periods_count'] = periodsCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to get active subscription details
         * @summary get active subscription details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/accounts/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @param customer: @param _: @return:
         * @summary update billing info of customer
         * @param {CustomerPatchModel} customerPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBillingInfo: async (customerPatchModel: CustomerPatchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerPatchModel' is not null or undefined
            assertParamExists('patchBillingInfo', 'customerPatchModel', customerPatchModel)
            const localVarPath = `/api/v1/accounts/customer/billingInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerPatchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to retry failed payments
         * @summary retry failed payments
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryPayment: async (invoiceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('retryPayment', 'invoiceId', invoiceId)
            const localVarPath = `/api/v1/accounts/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (invoiceId !== undefined) {
                localVarQueryParameter['invoice_id'] = invoiceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to update plan of customer
         * @summary update plan to customer
         * @param {SubscriptionModel} subscriptionModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription: async (subscriptionModel: SubscriptionModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionModel' is not null or undefined
            assertParamExists('updateSubscription', 'subscriptionModel', subscriptionModel)
            const localVarPath = `/api/v1/accounts/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManageAccountAndSubscriptionsApi - functional programming interface
 * @export
 */
export const ManageAccountAndSubscriptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ManageAccountAndSubscriptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * API to delete subscription
         * @summary delete subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSubscription(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSubscription(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManageAccountAndSubscriptionsApi.deleteSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to get billing info
         * @summary get billing info of customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillingInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillingInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManageAccountAndSubscriptionsApi.getBillingInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to retrieve current usage of customer
         * @summary get current usage of a customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUsage(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUsage(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManageAccountAndSubscriptionsApi.getCurrentUsage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to get customer url
         * @summary get stripe customer portal url
         * @param {string} redirectUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerURL(redirectUrl: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerURL(redirectUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManageAccountAndSubscriptionsApi.getCustomerURL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to get invoice data
         * @summary get invoice data
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoice(invoiceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoice(invoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManageAccountAndSubscriptionsApi.getInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to get all invoices
         * @summary get all invoices
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoices(startDate?: string, endDate?: string, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoicesModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoices(startDate, endDate, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManageAccountAndSubscriptionsApi.getInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to fetch historical customer usage data for closed billing periods
         * @summary fetch historical customer usage data for closed billing periods
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {string} [billableMetricCode] 
         * @param {number} [periodsCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPastUsage(page?: number, perPage?: number, billableMetricCode?: string, periodsCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPastUsage(page, perPage, billableMetricCode, periodsCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManageAccountAndSubscriptionsApi.getPastUsage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to get active subscription details
         * @summary get active subscription details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscription(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubscriptionResponseModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscription(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManageAccountAndSubscriptionsApi.getSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * @param customer: @param _: @return:
         * @summary update billing info of customer
         * @param {CustomerPatchModel} customerPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchBillingInfo(customerPatchModel: CustomerPatchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchBillingInfo(customerPatchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManageAccountAndSubscriptionsApi.patchBillingInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to retry failed payments
         * @summary retry failed payments
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryPayment(invoiceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryPayment(invoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManageAccountAndSubscriptionsApi.retryPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to update plan of customer
         * @summary update plan to customer
         * @param {SubscriptionModel} subscriptionModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubscription(subscriptionModel: SubscriptionModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubscription(subscriptionModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManageAccountAndSubscriptionsApi.updateSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ManageAccountAndSubscriptionsApi - factory interface
 * @export
 */
export const ManageAccountAndSubscriptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ManageAccountAndSubscriptionsApiFp(configuration)
    return {
        /**
         * API to delete subscription
         * @summary delete subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscription(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.deleteSubscription(options).then((request) => request(axios, basePath));
        },
        /**
         * API to get billing info
         * @summary get billing info of customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingInfo(options?: RawAxiosRequestConfig): AxiosPromise<Customer> {
            return localVarFp.getBillingInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * API to retrieve current usage of customer
         * @summary get current usage of a customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUsage(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getCurrentUsage(options).then((request) => request(axios, basePath));
        },
        /**
         * API to get customer url
         * @summary get stripe customer portal url
         * @param {ManageAccountAndSubscriptionsApiGetCustomerURLRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerURL(requestParameters: ManageAccountAndSubscriptionsApiGetCustomerURLRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getCustomerURL(requestParameters.redirectUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * API to get invoice data
         * @summary get invoice data
         * @param {ManageAccountAndSubscriptionsApiGetInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoice(requestParameters: ManageAccountAndSubscriptionsApiGetInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceModel> {
            return localVarFp.getInvoice(requestParameters.invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * API to get all invoices
         * @summary get all invoices
         * @param {ManageAccountAndSubscriptionsApiGetInvoicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices(requestParameters: ManageAccountAndSubscriptionsApiGetInvoicesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<InvoicesModel> {
            return localVarFp.getInvoices(requestParameters.startDate, requestParameters.endDate, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * API to fetch historical customer usage data for closed billing periods
         * @summary fetch historical customer usage data for closed billing periods
         * @param {ManageAccountAndSubscriptionsApiGetPastUsageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPastUsage(requestParameters: ManageAccountAndSubscriptionsApiGetPastUsageRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getPastUsage(requestParameters.page, requestParameters.perPage, requestParameters.billableMetricCode, requestParameters.periodsCount, options).then((request) => request(axios, basePath));
        },
        /**
         * API to get active subscription details
         * @summary get active subscription details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription(options?: RawAxiosRequestConfig): AxiosPromise<Array<SubscriptionResponseModel>> {
            return localVarFp.getSubscription(options).then((request) => request(axios, basePath));
        },
        /**
         * @param customer: @param _: @return:
         * @summary update billing info of customer
         * @param {ManageAccountAndSubscriptionsApiPatchBillingInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBillingInfo(requestParameters: ManageAccountAndSubscriptionsApiPatchBillingInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.patchBillingInfo(requestParameters.customerPatchModel, options).then((request) => request(axios, basePath));
        },
        /**
         * API to retry failed payments
         * @summary retry failed payments
         * @param {ManageAccountAndSubscriptionsApiRetryPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryPayment(requestParameters: ManageAccountAndSubscriptionsApiRetryPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.retryPayment(requestParameters.invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * API to update plan of customer
         * @summary update plan to customer
         * @param {ManageAccountAndSubscriptionsApiUpdateSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription(requestParameters: ManageAccountAndSubscriptionsApiUpdateSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.updateSubscription(requestParameters.subscriptionModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ManageAccountAndSubscriptionsApi - interface
 * @export
 * @interface ManageAccountAndSubscriptionsApi
 */
export interface ManageAccountAndSubscriptionsApiInterface {
    /**
     * API to delete subscription
     * @summary delete subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApiInterface
     */
    deleteSubscription(options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * API to get billing info
     * @summary get billing info of customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApiInterface
     */
    getBillingInfo(options?: RawAxiosRequestConfig): AxiosPromise<Customer>;

    /**
     * API to retrieve current usage of customer
     * @summary get current usage of a customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApiInterface
     */
    getCurrentUsage(options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * API to get customer url
     * @summary get stripe customer portal url
     * @param {ManageAccountAndSubscriptionsApiGetCustomerURLRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApiInterface
     */
    getCustomerURL(requestParameters: ManageAccountAndSubscriptionsApiGetCustomerURLRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * API to get invoice data
     * @summary get invoice data
     * @param {ManageAccountAndSubscriptionsApiGetInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApiInterface
     */
    getInvoice(requestParameters: ManageAccountAndSubscriptionsApiGetInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceModel>;

    /**
     * API to get all invoices
     * @summary get all invoices
     * @param {ManageAccountAndSubscriptionsApiGetInvoicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApiInterface
     */
    getInvoices(requestParameters?: ManageAccountAndSubscriptionsApiGetInvoicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<InvoicesModel>;

    /**
     * API to fetch historical customer usage data for closed billing periods
     * @summary fetch historical customer usage data for closed billing periods
     * @param {ManageAccountAndSubscriptionsApiGetPastUsageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApiInterface
     */
    getPastUsage(requestParameters?: ManageAccountAndSubscriptionsApiGetPastUsageRequest, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * API to get active subscription details
     * @summary get active subscription details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApiInterface
     */
    getSubscription(options?: RawAxiosRequestConfig): AxiosPromise<Array<SubscriptionResponseModel>>;

    /**
     * @param customer: @param _: @return:
     * @summary update billing info of customer
     * @param {ManageAccountAndSubscriptionsApiPatchBillingInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApiInterface
     */
    patchBillingInfo(requestParameters: ManageAccountAndSubscriptionsApiPatchBillingInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * API to retry failed payments
     * @summary retry failed payments
     * @param {ManageAccountAndSubscriptionsApiRetryPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApiInterface
     */
    retryPayment(requestParameters: ManageAccountAndSubscriptionsApiRetryPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * API to update plan of customer
     * @summary update plan to customer
     * @param {ManageAccountAndSubscriptionsApiUpdateSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApiInterface
     */
    updateSubscription(requestParameters: ManageAccountAndSubscriptionsApiUpdateSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

}

/**
 * Request parameters for getCustomerURL operation in ManageAccountAndSubscriptionsApi.
 * @export
 * @interface ManageAccountAndSubscriptionsApiGetCustomerURLRequest
 */
export interface ManageAccountAndSubscriptionsApiGetCustomerURLRequest {
    /**
     * 
     * @type {string}
     * @memberof ManageAccountAndSubscriptionsApiGetCustomerURL
     */
    readonly redirectUrl: string
}

/**
 * Request parameters for getInvoice operation in ManageAccountAndSubscriptionsApi.
 * @export
 * @interface ManageAccountAndSubscriptionsApiGetInvoiceRequest
 */
export interface ManageAccountAndSubscriptionsApiGetInvoiceRequest {
    /**
     * 
     * @type {string}
     * @memberof ManageAccountAndSubscriptionsApiGetInvoice
     */
    readonly invoiceId: string
}

/**
 * Request parameters for getInvoices operation in ManageAccountAndSubscriptionsApi.
 * @export
 * @interface ManageAccountAndSubscriptionsApiGetInvoicesRequest
 */
export interface ManageAccountAndSubscriptionsApiGetInvoicesRequest {
    /**
     * 
     * @type {string}
     * @memberof ManageAccountAndSubscriptionsApiGetInvoices
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof ManageAccountAndSubscriptionsApiGetInvoices
     */
    readonly endDate?: string

    /**
     * 
     * @type {number}
     * @memberof ManageAccountAndSubscriptionsApiGetInvoices
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof ManageAccountAndSubscriptionsApiGetInvoices
     */
    readonly pgSize?: number
}

/**
 * Request parameters for getPastUsage operation in ManageAccountAndSubscriptionsApi.
 * @export
 * @interface ManageAccountAndSubscriptionsApiGetPastUsageRequest
 */
export interface ManageAccountAndSubscriptionsApiGetPastUsageRequest {
    /**
     * 
     * @type {number}
     * @memberof ManageAccountAndSubscriptionsApiGetPastUsage
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ManageAccountAndSubscriptionsApiGetPastUsage
     */
    readonly perPage?: number

    /**
     * 
     * @type {string}
     * @memberof ManageAccountAndSubscriptionsApiGetPastUsage
     */
    readonly billableMetricCode?: string

    /**
     * 
     * @type {number}
     * @memberof ManageAccountAndSubscriptionsApiGetPastUsage
     */
    readonly periodsCount?: number
}

/**
 * Request parameters for patchBillingInfo operation in ManageAccountAndSubscriptionsApi.
 * @export
 * @interface ManageAccountAndSubscriptionsApiPatchBillingInfoRequest
 */
export interface ManageAccountAndSubscriptionsApiPatchBillingInfoRequest {
    /**
     * 
     * @type {CustomerPatchModel}
     * @memberof ManageAccountAndSubscriptionsApiPatchBillingInfo
     */
    readonly customerPatchModel: CustomerPatchModel
}

/**
 * Request parameters for retryPayment operation in ManageAccountAndSubscriptionsApi.
 * @export
 * @interface ManageAccountAndSubscriptionsApiRetryPaymentRequest
 */
export interface ManageAccountAndSubscriptionsApiRetryPaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof ManageAccountAndSubscriptionsApiRetryPayment
     */
    readonly invoiceId: string
}

/**
 * Request parameters for updateSubscription operation in ManageAccountAndSubscriptionsApi.
 * @export
 * @interface ManageAccountAndSubscriptionsApiUpdateSubscriptionRequest
 */
export interface ManageAccountAndSubscriptionsApiUpdateSubscriptionRequest {
    /**
     * 
     * @type {SubscriptionModel}
     * @memberof ManageAccountAndSubscriptionsApiUpdateSubscription
     */
    readonly subscriptionModel: SubscriptionModel
}

/**
 * ManageAccountAndSubscriptionsApi - object-oriented interface
 * @export
 * @class ManageAccountAndSubscriptionsApi
 * @extends {BaseAPI}
 */
export class ManageAccountAndSubscriptionsApi extends BaseAPI implements ManageAccountAndSubscriptionsApiInterface {
    /**
     * API to delete subscription
     * @summary delete subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApi
     */
    public deleteSubscription(options?: RawAxiosRequestConfig) {
        return ManageAccountAndSubscriptionsApiFp(this.configuration).deleteSubscription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to get billing info
     * @summary get billing info of customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApi
     */
    public getBillingInfo(options?: RawAxiosRequestConfig) {
        return ManageAccountAndSubscriptionsApiFp(this.configuration).getBillingInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to retrieve current usage of customer
     * @summary get current usage of a customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApi
     */
    public getCurrentUsage(options?: RawAxiosRequestConfig) {
        return ManageAccountAndSubscriptionsApiFp(this.configuration).getCurrentUsage(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to get customer url
     * @summary get stripe customer portal url
     * @param {ManageAccountAndSubscriptionsApiGetCustomerURLRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApi
     */
    public getCustomerURL(requestParameters: ManageAccountAndSubscriptionsApiGetCustomerURLRequest, options?: RawAxiosRequestConfig) {
        return ManageAccountAndSubscriptionsApiFp(this.configuration).getCustomerURL(requestParameters.redirectUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to get invoice data
     * @summary get invoice data
     * @param {ManageAccountAndSubscriptionsApiGetInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApi
     */
    public getInvoice(requestParameters: ManageAccountAndSubscriptionsApiGetInvoiceRequest, options?: RawAxiosRequestConfig) {
        return ManageAccountAndSubscriptionsApiFp(this.configuration).getInvoice(requestParameters.invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to get all invoices
     * @summary get all invoices
     * @param {ManageAccountAndSubscriptionsApiGetInvoicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApi
     */
    public getInvoices(requestParameters: ManageAccountAndSubscriptionsApiGetInvoicesRequest = {}, options?: RawAxiosRequestConfig) {
        return ManageAccountAndSubscriptionsApiFp(this.configuration).getInvoices(requestParameters.startDate, requestParameters.endDate, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to fetch historical customer usage data for closed billing periods
     * @summary fetch historical customer usage data for closed billing periods
     * @param {ManageAccountAndSubscriptionsApiGetPastUsageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApi
     */
    public getPastUsage(requestParameters: ManageAccountAndSubscriptionsApiGetPastUsageRequest = {}, options?: RawAxiosRequestConfig) {
        return ManageAccountAndSubscriptionsApiFp(this.configuration).getPastUsage(requestParameters.page, requestParameters.perPage, requestParameters.billableMetricCode, requestParameters.periodsCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to get active subscription details
     * @summary get active subscription details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApi
     */
    public getSubscription(options?: RawAxiosRequestConfig) {
        return ManageAccountAndSubscriptionsApiFp(this.configuration).getSubscription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * @param customer: @param _: @return:
     * @summary update billing info of customer
     * @param {ManageAccountAndSubscriptionsApiPatchBillingInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApi
     */
    public patchBillingInfo(requestParameters: ManageAccountAndSubscriptionsApiPatchBillingInfoRequest, options?: RawAxiosRequestConfig) {
        return ManageAccountAndSubscriptionsApiFp(this.configuration).patchBillingInfo(requestParameters.customerPatchModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to retry failed payments
     * @summary retry failed payments
     * @param {ManageAccountAndSubscriptionsApiRetryPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApi
     */
    public retryPayment(requestParameters: ManageAccountAndSubscriptionsApiRetryPaymentRequest, options?: RawAxiosRequestConfig) {
        return ManageAccountAndSubscriptionsApiFp(this.configuration).retryPayment(requestParameters.invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to update plan of customer
     * @summary update plan to customer
     * @param {ManageAccountAndSubscriptionsApiUpdateSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageAccountAndSubscriptionsApi
     */
    public updateSubscription(requestParameters: ManageAccountAndSubscriptionsApiUpdateSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return ManageAccountAndSubscriptionsApiFp(this.configuration).updateSubscription(requestParameters.subscriptionModel, options).then((request) => request(this.axios, this.basePath));
    }
}

